import { render, staticRenderFns } from "./VentaTaquillaComponent.vue?vue&type=template&id=aac1761c"
import script from "./VentaTaquillaComponent.vue?vue&type=script&lang=js"
export * from "./VentaTaquillaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports